export type CashierStaffMember = {
  user_id: string;
  clinic_id?: string | null;
  status?: string | null;
  user?: { name?: string | null; email?: string | null } | null;
  name?: string | null;
  email?: string | null;
};

export type CashierPractitionerOption = {
  id: string;
  label: string;
};

/**
 * Clinics whose active staff appear in the cashier Practitioner dropdown.
 * Matches the report location scope: the current clinic, plus any selected
 * subclinics. Empty locationIds means "current clinic only", same as the RPC.
 */
export function clinicIdsForCashierStaff(
  activeClinicId: string | null | undefined,
  locationIds: string[] = [],
): string[] {
  const ids = new Set<string>();
  if (activeClinicId) ids.add(activeClinicId);
  for (const id of locationIds) {
    if (id) ids.add(id);
  }
  return [...ids];
}

export function cashierPractitionerLabel(member: CashierStaffMember): string {
  const name = member.user?.name?.trim() || member.name?.trim();
  if (name) return name;
  return member.user?.email?.trim() || member.email?.trim() || member.user_id;
}

/**
 * Practitioner filter OPTIONS from clinic memberships — not from payments,
 * invoices, or appointments. A member with zero transactions still appears.
 */
export function cashierPractitionerOptions(
  members: CashierStaffMember[],
  options: { includeInactive?: boolean } = {},
): CashierPractitionerOption[] {
  const includeInactive = Boolean(options.includeInactive);
  const byId = new Map<string, CashierPractitionerOption>();

  for (const member of members) {
    if (!member.user_id) continue;
    if (!includeInactive && member.status && member.status !== 'active') continue;
    if (byId.has(member.user_id)) continue;
    byId.set(member.user_id, {
      id: member.user_id,
      label: cashierPractitionerLabel(member),
    });
  }

  return [...byId.values()].sort((a, b) => a.label.localeCompare(b.label, undefined, { sensitivity: 'base' }));
}
